import { useEffect, useState, type FormEvent } from "react";
import { Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

/** Find an e-invoice by its network id (SDI: IdentificativoSdI). Applied on submit, since a partial id matches nothing. */
export function NetworkReferenceSearch({
  value,
  onChange,
}: {
  value?: string;
  onChange: (reference: string | null) => void;
}) {
  const [text, setText] = useState(value ?? "");
  useEffect(() => setText(value ?? ""), [value]);

  function submit(e: FormEvent) {
    e.preventDefault();
    const trimmed = text.trim();
    onChange(trimmed.length > 0 ? trimmed : null);
  }

  return (
    <form onSubmit={submit} className="flex items-center gap-2">
      <div className="relative">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="SDI / network id"
          aria-label="Find by network id"
          className="w-56 pl-8 font-mono"
        />
      </div>
      <Button type="submit" variant="outline" size="sm">
        Find
      </Button>
      {value && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-8"
          aria-label="Clear network id"
          onClick={() => {
            setText("");
            onChange(null);
          }}
        >
          <X className="size-4" />
        </Button>
      )}
    </form>
  );
}
